import {gql} from '@apollo/client';

export const removeSplitterMutation = gql`
    mutation RemoveSplitter($id: ID!) {
        removeSplitter(id: $id) {
            id
        }
    }
`;